module.exports = __webpack_public_path__ + "img/Comic04-1.ae29ff8f.png";